import React, { useEffect } from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'
import { data } from "../data/data.js";


const Work = () => {
  useEffect(() => {
    AOS.init({ duration: 2500 });
  }, []);

  // projects file
  const project = data;
  //setProject(data);

  return (
    <div name='work' className='w-full md:h-screen text-gray-300 bg-[#0a192f]'>
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div data-aos='fade' className='pb-8 mt-[4rem] md:mt-[12rem]'>
          <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
            Work
          </p>
          <p className='py-6'>Check out some of my recent work</p>
        </div>

        {/* container for projects */}
        <div data-aos='fade' className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">

          {/* Gird Item */}
          {project.map((item, index) => (
            <>
              <div
                key={index}
                style={{ backgroundImage: `url(${item.image})` }}
                className="shadow-lg shadow-[#040c16] group container rounded-md 
              flex justify-center text-center items-center mx-auto content-div hover:scale-105 hover:duration-700 cursor-default"
              >
                {/* Hover effect for images */}
                <div className="opacity-0 group-hover:opacity-100 transition-all duration-150">
                  <h1 className="text-3xl font-bold text-white tracking-wider px-4">
                    {item.projectName}
                  </h1>
                  <span className="text-lg font-semibold text-white tracking-wider">
                    {`(${item.name})`}
                  </span>
                  <p className="text-base font-normal text-white tracking-wider px-4">
                    {`${item.description}`}
                  </p>
                  <div className="pt-2 text-center ">
                    {/* eslint-disable-next-line */}
                    <a href={item.github} target="_blank">
                      <button
                        className="text-center rounded-sm w-[80px] py-1 m-2
                        text-white font-bold text-lg border-2 hover:bg-pink-600 hover:border-pink-600"
                      >
                        Github
                      </button>
                    </a>
                    {/* eslint-disable-next-line */}
                    <a href={item.live} target="_blank">
                      <button
                        className="text-center rounded-sm w-[80px] py-1 m-2
                        text-white font-bold text-lg border-2 hover:bg-pink-600 hover:border-pink-600"
                      >
                        Demo
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </>
          ))}


        </div>
      </div>
    </div>
  );
};

export default Work;
